var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.98678C14.0071 10.8436 10.8618 13.9973 7.00507 14C5.33933 14.0012 3.80927 13.4205 2.60688 12.4501C2.29422 12.1978 2.27085 11.7292 2.55497 11.4451L2.87299 11.127C3.11599 10.884 3.50392 10.8574 3.77314 11.071C4.659 11.774 5.7801 12.1936 6.99999 12.1936C9.8707 12.1936 12.1935 9.87027 12.1935 7.00001C12.1935 4.1293 9.87025 1.80646 6.99999 1.80646C5.62218 1.80646 4.37079 2.34187 3.44163 3.21583L4.8742 4.6484C5.15871 4.93292 4.95721 5.41937 4.55488 5.41937H0.451613C0.202181 5.41937 0 5.21718 0 4.96775V0.864473C0 0.462142 0.486443 0.260638 0.770959 0.545126L2.16452 1.93869C3.42122 0.737711 5.12445 0 6.99999 0C10.8616 0 13.9928 3.12686 14 6.98678Z",
    fill: "#65707B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default ForwardRef;